// Rotates the cart drawer announcement messages. Auto-advances only when there
// is more than one message. Safe to re-instantiate on cart re-render.
if (!customElements.get('cart-announcement-rotator')) {
  class CartAnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.cart-drawer__announcement-slide'));
      if (this.slides.length === 0) return;

      this.index = 0;
      this.show(0);

      if (this.slides.length > 1) {
        const interval = parseInt(this.dataset.interval, 10) || 4000;
        this.timer = setInterval(() => this.next(), Math.max(1500, interval));
      }
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    show(i) {
      this.slides.forEach((slide, idx) => {
        slide.classList.toggle('is-active', idx === i);
      });
    }

    next() {
      this.index = (this.index + 1) % this.slides.length;
      this.show(this.index);
    }
  }

  customElements.define('cart-announcement-rotator', CartAnnouncementRotator);
}
